export interface EstateBroker {
  id: string;
  name: string;
  phone: string;
  email: string;
  role?: string;
  image?: string;
  category?: 'sales' | 'rentals' | 'office';
}

export const ESTATE_BROKERS: EstateBroker[] = [
  {
    id: "ef8d6402-df3c-43c1-8fb8-aaa200aee228",
    name: "Ваня Бабаколова",
    phone: "0878 859 385",
    email: "imotencentervar@abv.bg",
    role: "Управител & Старши Брокер",
    category: "sales"
  },
  {
    id: "01e77341-1cd9-4660-9dda-aae2008a6a78",
    name: "Иван Иванов",
    phone: "0877 935 855",
    email: "ivanivanov@abv.bg",
    role: "Брокер Продажби",
    category: "sales"
  },
  {
    id: "72903b85-02a4-4a32-a234-aae2008e6af3",
    name: "Радослав Илиев",
    phone: "0877 004 318",
    email: "radoslaviliev@abv.bg",
    role: "Брокер Продажби & Инвестиции",
    category: "sales"
  },
  {
    id: "74a559cc-1413-44ee-a26f-aae200945029",
    name: "Атанас Кръстев",
    phone: "0889 411 079",
    email: "atanaskrastev@abv.bg",
    role: "Брокер Недвижими Имоти",
    category: "sales"
  },
  {
    id: "a8b96966-4e5e-4364-8f14-aae200950643",
    name: "Пролет Екупова",
    phone: "0877 934 829",
    email: "proletekupova@abv.bg",
    role: "Брокер Наеми и Продажби",
    category: "rentals"
  },
  {
    id: "a61bf12f-901e-44ca-81e8-aae20096d0fa",
    name: "Явор Георгиев",
    phone: "0879 000 923",
    email: "iavorgeorgiev@abv.bg",
    role: "Брокер Недвижими Имоти",
    category: "sales"
  },
  {
    id: "f1c8c9c3-0785-4546-9c42-abe90088a582",
    name: "Росен Димитров",
    phone: "0877 935 798",
    email: "rosendimitrov@abv.bg",
    role: "Брокер Недвижими Имоти",
    category: "sales"
  },
  {
    id: "842c2f4f-f275-4123-9b11-ac4500daf182",
    name: "Теодор Тамахкяров",
    phone: "0877 936 835",
    email: "teodortamahkqrov@abv.bg",
    role: "Брокер Продажби",
    category: "sales"
  },
  {
    id: "68b5210c-f60b-4216-a195-acaf007d4192",
    name: "Николай Монев",
    phone: "0878 832 898",
    email: "zdravkozdravkov@abv.bg",
    role: "Брокер Продажби",
    category: "sales"
  },
  {
    id: "0b2e65f6-6097-4c94-8ea8-acf500b32d6f",
    name: "Боряна Георгиева",
    phone: "0878 863 784",
    email: "radoslavstefanov@abv.bg",
    role: "Брокер Недвижими Имоти",
    category: "sales"
  },
  {
    id: "5752c338-7eb3-4632-929b-ad1200d89f5a",
    name: "Самуил Батанов",
    phone: "0877 927 942",
    email: "fatmeahmed@abv.bg",
    role: "Брокер Наеми",
    category: "rentals"
  },
  {
    id: "6def7095-408c-48a8-a23d-ad3200b0f9e5",
    name: "Ибрахим Узунов",
    phone: "0877 937 907",
    email: "ivanetametodieva@abv.bg",
    role: "Брокер Недвижими Имоти",
    category: "sales"
  },
  {
    id: "bb8652d5-499d-40b5-8917-ad7100dec4b2",
    name: "Йордан Дечев",
    phone: "0878 737 800",
    email: "daripetrova@abv.bg",
    role: "Брокер Продажби",
    category: "sales"
  },
  {
    id: "079cbd54-947c-4cfd-84fc-ad7200beb1b8",
    name: "Радко Радков",
    phone: "0877 935 767",
    email: "aleksandargeorgiev@abv.bg",
    role: "Брокер Недвижими Имоти",
    category: "sales"
  }
];

export function findBrokerByNameOrId(nameOrId?: string): EstateBroker | undefined {
  if (!nameOrId) return undefined;
  const query = nameOrId.trim().toLowerCase();
  return ESTATE_BROKERS.find(b => 
    b.id.toLowerCase() === query || 
    b.name.toLowerCase() === query ||
    b.name.toLowerCase().includes(query)
  );
}

export const DEFAULT_AGENTS_FROM_BROKERS = ESTATE_BROKERS.map((b, idx) => ({
  id: b.id,
  name: b.name,
  role: b.role || 'Брокер Недвижими Имоти',
  phone: b.phone,
  email: b.email,
  category: b.category || 'sales',
  order: idx + 1,
  image: b.image || 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&fit=crop&q=80'
}));
